import React from "react";
import storage from "@utils/storage";
import LenderDashboard from "./LenderDashboard";
import BorrowerDashboard from "./BorrowerDashboard";

function Dashboard() {
  const Id = storage.getUser();
  const role = Id?.role;

  return (
    <>
      {role === "lender" && (
        <div className="dashboard-wrapper">
          <LenderDashboard></LenderDashboard>
        </div>
      )}

      {role === "borrower" && (
        <div className="dashboard-wrapper">
          <BorrowerDashboard></BorrowerDashboard>
        </div>
      )}

      {!role && (
        <div className="dashboard-wrapper">
          <h2>Loading...</h2>
        </div>
      )}
    </>
  );
}

export default Dashboard;
